import React, { useState, useEffect, useImperativeHandle } from "react";
import i18n from "../../Services/i18n";
import styles from "./ChangePasswordModal.module.css";
import PasswordInput from "../../LayoutComponents/PasswordInput";

const ChangePasswordModal = ({ ref }) => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");

  const PASSWORD_RGX =
    /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z\d])[A-Za-z\d_\W]{8,}$/;
  useImperativeHandle(ref, () => ({
    isValid() {
      const isPasswordValid = PASSWORD_RGX.test(newPassword);
      const passwordsMatch =
        newPassword.trim() !== "" &&
        newPassword.trim() === confirmNewPassword.trim();
      return isPasswordValid && passwordsMatch;
    },
    newPassword() {
      return newPassword;
    },
    oldPassword() {
      return oldPassword;
    },
  }));

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className={styles.container}>
        <p>
          <strong>{i18n.t("ChangePassword.FirstParagraph")}</strong>
        </p>
        <p>{i18n.t("ChangePassword.SecondParagraph")}</p>
        <p className={styles.validationMessage}>
          {i18n.t("ChangePassword.passwordvalidation")}
        </p>
        <div className={styles.row}>
          <div className={styles.leftSectionLabelKey}>
            <label>{i18n.t("ChangePassword.OldPassword")}: </label>
          </div>
          <div className={styles.leftSectionLabelValue}>
            <PasswordInput
              className={styles.input}
              value={oldPassword}
              onChange={(e) => {
                setOldPassword(e.target.value);
              }}
            />
          </div>
        </div>
        <div className={styles.row}>
          <div className={styles.leftSectionLabelKey}>
            <label>{i18n.t("ChangePassword.NewPassword")}: </label>
          </div>
          <div className={styles.leftSectionLabelValue}>
            <PasswordInput
              className={styles.input}
              value={newPassword}
              onChange={(e) => {
                setNewPassword(e.target.value);
              }}
            />
          </div>
        </div>
        <div className={styles.row}>
          <div className={styles.leftSectionLabelKey}>
            <label>{i18n.t("ChangePassword.ConfirmNewPassword")}: </label>
          </div>
          <div className={styles.leftSectionLabelValue}>
            <PasswordInput
              className={styles.input}
              value={confirmNewPassword}
              onChange={(e) => {
                setConfirmNewPassword(e.target.value);
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ChangePasswordModal;
